import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './edit-button.component.html',
  styleUrl: './edit-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditButtonComponent {
  readonly hasPermission = input<boolean>(false);

  @Output() readonly onEditClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.onEditClicked.emit();
  }
}
